import messages from 'constants/messages';
import { parseFloatsInOtherBatnas } from 'components/formula-entry/modals/costs/selectors';
import { IPrice } from 'store/field-options/types';

export interface IErrorPrice {
  costFreight: string;
  costReimbursed: string;
  costFixed?: string;
  costIncInventory?: string;
  costTransitDays?: string;
}

export interface IInitialStateProps {
  priceCostFreight: string;
  priceCostReimbursed: string;
  priceCostFixed: string;
  priceCostIncInventory: string;
  priceCostTransitDays: string;
  batnaCostFreight: string;
  batnaCostReimbursed: string;
  batnaCostFixed: string;
  batnaCostIncInventory: string;
  batnaCostTransitDays: string;
  otherBatnas: IPrice[];
  mfgCostName: string;
  mfgCostFormulaItp: string;
  mfgCostFormulaTrue: string;
}

export interface IErrorsInitialStatesProps {
  priceCostFreight: string;
  priceCostReimbursed: string;
  priceCostFixed: string;
  priceCostIncInventory: string;
  priceCostTransitDays: string;
  batnaCostFreight: string;
  batnaCostReimbursed: string;
  batnaCostFixed: string;
  batnaCostIncInventory: string;
  batnaCostTransitDays: string;
  otherBatnas: IErrorPrice[];
}
export const errorsInitialState: IErrorsInitialStatesProps = {
  priceCostFreight: '',
  priceCostReimbursed: '',
  priceCostFixed: '',
  priceCostIncInventory: '',
  priceCostTransitDays: '',
  batnaCostFreight: '',
  batnaCostReimbursed: '',
  batnaCostFixed: '',
  batnaCostIncInventory: '',
  batnaCostTransitDays: '',
  otherBatnas: [],
};

export const initialState: IInitialStateProps = {
  priceCostFreight: '',
  priceCostReimbursed: '',
  priceCostFixed: '',
  priceCostIncInventory: '',
  priceCostTransitDays: '',
  batnaCostFreight: '',
  batnaCostReimbursed: '',
  batnaCostFixed: '',
  batnaCostIncInventory: '',
  batnaCostTransitDays: '',
  mfgCostName: '',
  mfgCostFormulaItp: '',
  mfgCostFormulaTrue: '',
  otherBatnas: [],
};

const getPriceCostFixedParsed = (costs: IInitialStateProps) => {
  return costs.priceCostFixed ? parseFloat(costs.priceCostFixed) : 0;
};

const getPriceCostIncInventoryParsed = (costs: IInitialStateProps) => {
  return costs.priceCostIncInventory ? parseFloat(costs.priceCostIncInventory) : 0;
};

const getPriceCostTransitDaysParsed = (costs: IInitialStateProps) => {
  return costs.priceCostTransitDays ? parseFloat(costs.priceCostTransitDays) : 0;
};

const getBatnaCostFixedParsed = (costs: IInitialStateProps) => {
  return costs.batnaCostFixed ? parseFloat(costs.batnaCostFixed) : 0;
};

const getBatnaCostIncInventoryParsed = (costs: IInitialStateProps) => {
  return costs.batnaCostIncInventory ? parseFloat(costs.batnaCostIncInventory) : 0;
};

const getBatnaCostTransitDaysParsed = (costs: IInitialStateProps) => {
  return costs.batnaCostTransitDays ? parseFloat(costs.batnaCostTransitDays) : 0;
};

const checkPriceReimbursedParsedValue = (priceReimbursedParsed: number) => {
  return Number.isNaN(priceReimbursedParsed) || priceReimbursedParsed < 0;
};

const checkPriceCostFreightParsedValue = (priceCostFreightParsed: number) => {
  return Number.isNaN(priceCostFreightParsed) || priceCostFreightParsed < 0;
};

const checkPriceCostFixedParsedValue = (priceCostFixedParsed: number) => {
  return Number.isNaN(priceCostFixedParsed) || priceCostFixedParsed < 0;
};

const checkPriceCostIncInventoryParsedValue = (priceCostIncInventoryParsed: number) => {
  return Number.isNaN(priceCostIncInventoryParsed) || priceCostIncInventoryParsed < 0;
};

const checkPriceCostTransitDaysParsedValue = (priceCostTransitDaysParsed: number) => {
  return Number.isNaN(priceCostTransitDaysParsed) || priceCostTransitDaysParsed < 0;
};

const checkBatnaReimbursedParsedValue = (batnaReimbursedParsed: number) => {
  return Number.isNaN(batnaReimbursedParsed) || batnaReimbursedParsed < 0;
};

const checkBatnaCostFreightParsedValue = (batnaCostFreightParsed: number) => {
  return Number.isNaN(batnaCostFreightParsed) || batnaCostFreightParsed < 0;
};

const checkBatnaCostFixedParsedValue = (batnaCostFixedParsed: number) => {
  return Number.isNaN(batnaCostFixedParsed) || batnaCostFixedParsed < 0;
};

const checkBatnaCostIncInventoryParsedValue = (batnaCostIncInventoryParsed: number) => {
  return Number.isNaN(batnaCostIncInventoryParsed) || batnaCostIncInventoryParsed < 0;
};

const checkBatnaCostTransitDaysParsedValue = (batnaCostTransitDaysParsed: number) => {
  return Number.isNaN(batnaCostTransitDaysParsed) || batnaCostTransitDaysParsed < 0;
};

const checkOtherBatnaParsedCostFreighValue = (otherBatnaParsed: { costFreight: number }) => {
  return Number.isNaN(otherBatnaParsed.costFreight) || otherBatnaParsed.costFreight < 0;
};

const checkOtherBatnaParsedCostFixedValue = (otherBatnaParsed: { costFixed: number }) => {
  return Number.isNaN(otherBatnaParsed.costFixed) || otherBatnaParsed.costFixed < 0;
};

const checkOtherBatnaParsedCostIncInventoryValue = (otherBatnaParsed: { costIncInventory: number }) => {
  return Number.isNaN(otherBatnaParsed.costIncInventory) || otherBatnaParsed.costIncInventory < 0;
};

const checkOtherBatnaParsedCostTransitDaysValue = (otherBatnaParsed: { costTransitDays: number }) => {
  return Number.isNaN(otherBatnaParsed.costTransitDays) || otherBatnaParsed.costTransitDays < 0;
};

const checkOtherBatnaParsedCostReimbursedValue = (otherBatnaParsed: { costReimbursed: number }) => {
  return Number.isNaN(otherBatnaParsed.costReimbursed) || otherBatnaParsed.costReimbursed < 0;
};

const ValidateInputValuesPositiveNumbers = (
  newErrors: IErrorsInitialStatesProps,
  priceReimbursedParsed: number,
  priceCostFreightParsed: number,
  priceCostFixedParsed: number,
  priceCostIncInventoryParsed: number,
  priceCostTransitDaysParsed: number
) => {
  // Parse otherBatna input string values
  const processNewErrors = newErrors;
  if (checkPriceReimbursedParsedValue(priceReimbursedParsed)) {
    processNewErrors.priceCostReimbursed = messages.errors.invalidNumber;
  }
  if (checkPriceCostFreightParsedValue(priceCostFreightParsed)) {
    processNewErrors.priceCostFreight = messages.errors.invalidNumber;
  }
  if (checkPriceCostFixedParsedValue(priceCostFixedParsed)) {
    processNewErrors.priceCostFixed = messages.errors.invalidNumber;
  }
  if (checkPriceCostIncInventoryParsedValue(priceCostIncInventoryParsed)) {
    processNewErrors.priceCostIncInventory = messages.errors.invalidNumber;
  }
  if (checkPriceCostTransitDaysParsedValue(priceCostTransitDaysParsed)) {
    processNewErrors.priceCostTransitDays = messages.errors.invalidNumber;
  }
  return processNewErrors;
};

const ValidateInputValuesPositiveNumbersForBatna = (
  newErrors: IErrorsInitialStatesProps,
  batnaReimbursedParsed: number,
  batnaCostFreightParsed: number,
  batnaCostFixedParsed: number,
  batnaCostIncInventoryParsed: number,
  batnaCostTransitDaysParsed: number
) => {
  const processNewErrors = newErrors;
  if (checkBatnaReimbursedParsedValue(batnaReimbursedParsed)) {
    processNewErrors.batnaCostReimbursed = messages.errors.invalidNumber;
  }
  if (checkBatnaCostFreightParsedValue(batnaCostFreightParsed)) {
    processNewErrors.batnaCostFreight = messages.errors.invalidNumber;
  }
  if (checkBatnaCostFixedParsedValue(batnaCostFixedParsed)) {
    processNewErrors.batnaCostFixed = messages.errors.invalidNumber;
  }
  if (checkBatnaCostIncInventoryParsedValue(batnaCostIncInventoryParsed)) {
    processNewErrors.batnaCostIncInventory = messages.errors.invalidNumber;
  }
  if (checkBatnaCostTransitDaysParsedValue(batnaCostTransitDaysParsed)) {
    processNewErrors.batnaCostTransitDays = messages.errors.invalidNumber;
  }
  return processNewErrors;
};

export function getNewErrorsAndAreOtherBatnasErrorFree(costs: IInitialStateProps) {
  // Initialize new error object
  let newErrors = { ...errorsInitialState };

  // Parse numbers
  const priceReimbursedParsed = parseFloat(costs.priceCostReimbursed);
  const priceCostFreightParsed = parseFloat(costs.priceCostFreight);
  const priceCostFixedParsed = getPriceCostFixedParsed(costs);
  const priceCostIncInventoryParsed = getPriceCostIncInventoryParsed(costs);
  const priceCostTransitDaysParsed = getPriceCostTransitDaysParsed(costs);

  const batnaReimbursedParsed = parseFloat(costs.batnaCostReimbursed);
  const batnaCostFreightParsed = parseFloat(costs.batnaCostFreight);
  const batnaCostFixedParsed = getBatnaCostFixedParsed(costs);
  const batnaCostIncInventoryParsed = getBatnaCostIncInventoryParsed(costs);
  const batnaCostTransitDaysParsed = getBatnaCostTransitDaysParsed(costs);

  // Validate input values are positive numbers
  newErrors = ValidateInputValuesPositiveNumbers(
    newErrors,
    priceReimbursedParsed,
    priceCostFreightParsed,
    priceCostFixedParsed,
    priceCostIncInventoryParsed,
    priceCostTransitDaysParsed
  );

  newErrors = ValidateInputValuesPositiveNumbersForBatna(
    newErrors,
    batnaReimbursedParsed,
    batnaCostFreightParsed,
    batnaCostFixedParsed,
    batnaCostIncInventoryParsed,
    batnaCostTransitDaysParsed
  );
  // Parse otherBatna input string values
  const otherBatnasParsed = parseFloatsInOtherBatnas(costs.otherBatnas);
  let areOtherBatnasErrorFree = true;

  // Validate x number of otherBatnas (costFreight, costReimbursed)
  otherBatnasParsed.forEach((otherBatnaParsed, index) => {
    if (checkOtherBatnaParsedCostFreighValue(otherBatnaParsed)) {
      newErrors.otherBatnas[index].costFreight = messages.errors.invalidNumber;
      areOtherBatnasErrorFree = false;
    }
    if (checkOtherBatnaParsedCostFixedValue(otherBatnaParsed)) {
      newErrors.otherBatnas[index].costFixed = messages.errors.invalidNumber;
      areOtherBatnasErrorFree = false;
    }
    if (checkOtherBatnaParsedCostIncInventoryValue(otherBatnaParsed)) {
      newErrors.otherBatnas[index].costIncInventory = messages.errors.invalidNumber;
      areOtherBatnasErrorFree = false;
    }
    if (checkOtherBatnaParsedCostTransitDaysValue(otherBatnaParsed)) {
      newErrors.otherBatnas[index].costTransitDays = messages.errors.invalidNumber;
      areOtherBatnasErrorFree = false;
    }
    if (checkOtherBatnaParsedCostReimbursedValue(otherBatnaParsed)) {
      newErrors.otherBatnas[index].costReimbursed = messages.errors.invalidNumber;
      areOtherBatnasErrorFree = false;
    }
  });

  return {
    newErrors,
    areOtherBatnasErrorFree,
    priceCostFreightParsed,
    priceReimbursedParsed,
    priceCostFixedParsed,
    priceCostIncInventoryParsed,
    priceCostTransitDaysParsed,
    batnaCostFreightParsed,
    batnaReimbursedParsed,
    batnaCostIncInventoryParsed,
    batnaCostTransitDaysParsed,
    batnaCostFixedParsed,
    otherBatnasParsed,
  };
}
